import { ReactNode } from 'react';
import { Colors } from 'src/utils/colors';

export enum Order {
  ASC = 'ASC',
  DESC = 'DESC',
}

export interface TableSortParameters<T> {
  mode?: Order;
  key?: keyof T | string;
}

export interface TableQueryParameters<S = void, T = void>
  extends TableSortParameters<T> {
  page?: number;
  size?: number;
  q?: string;
  s?: S | S[];
  bounds?: string;
}

export interface ServiceAccountTableQueryParameters<S = void, T = void>
  extends TableQueryParameters<S, T> {
  autoAssign?: number;
}

export interface TableHeader<T> {
  label: string | ReactNode;
  accessor: keyof T;
  component?: (props: T, index?: number) => ReactNode;
  sortable?: boolean;
  sortKey?: string;
  align?: 'left' | 'right' | 'center';
  fontWeight?: number;
}

export interface TableFilter<S> {
  label: string;
  value: S;
  color: keyof Colors;
}

export interface Ctx<S> {
  size: number;
  page: number;
  mode: string;
  s: S;
  key: string;
}

export interface ApiPaginationResponse<T, S = void> {
  data: T;
  count: number;
  ctx?: Ctx<S>;
}
